
import { createSelector } from 'reselect';

const getConfigFromState = state => state.config;

const getDataFromState = state => state.data;

const getDomainFromState = state => state.config.domain;

const getLangFromState = state => state.lang;

const getNavigationFromState = state => state.navigation;

const getUiFromState = state => state.ui;

export const getConfig = createSelector(
    [ getConfigFromState ],
    config => config
);

export const getData = createSelector(
    [ getDataFromState ],
    meta => meta
);

export const getDomain = createSelector(
    [ getDomainFromState ],
    domain => domain
);

export const getLang = createSelector(
    [ getLangFromState ],
    lang => lang
);

export const getNavigation = createSelector(
    [ getNavigationFromState ],
    navigation => navigation
);

export const getUi = createSelector(
    [ getUiFromState ],
    ui => ui
);



// WEBPACK FOOTER //
// ./src/selectors/index.js